import clsx from "clsx"
import { ReactElement, cloneElement, isValidElement } from "react"

import { Skeleton, TruncatableText } from "@particles/index"

import useObjectCard from "@molecules/ObjectCard/ObjectCard.context"

import styles from "./ObjectCardBody.module.scss"
import { ObjectCardBodyProps } from "./ObjectCardBody.types"

export default function ObjectCardBody(props: ObjectCardBodyProps) {
    const {
        avatar,
        primaryText,
        secondaryText,
        secondaryTextPlaceholder,
        secondaryTextTooltip,
        secondaryTextTooltipAlways = false,
        className,
    } = props

    const { isLoading } = useObjectCard()

    if (isLoading) {
        return (
            <div className={clsx(styles.base, className)}>
                {isValidElement(avatar) &&
                    cloneElement(avatar as ReactElement<{ isLoading?: boolean }>, { isLoading: true })}
                <div className={styles.textColumn}>
                    <div className={styles.primarySkeleton}>
                        <Skeleton height={11} borderRadius={0} width="100%" />
                    </div>
                    <div className={styles.secondarySkeleton}>
                        <Skeleton height={10} borderRadius={0} width="100%" />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.base, className)}>
                {avatar}
                <div className={styles.textColumn}>
                    <TruncatableText className={styles.primaryText} text={primaryText} tooltipOnTruncate={false} />
                    {secondaryText ? (
                        <TruncatableText
                            className={styles.secondaryText}
                            text={secondaryText}
                            tooltipOverride={secondaryTextTooltip}
                            tooltipOnTruncate={true}
                            alwaysShowTooltip={secondaryTextTooltipAlways}
                            tooltipPlacement="bottom"
                        />
                    ) : secondaryTextPlaceholder ? (
                        <span className={clsx(styles.secondaryText, styles.placeholder)}>
                            {secondaryTextPlaceholder}
                        </span>
                    ) : null}
                </div>
            </div>
        )
    }
}
